// extracted by mini-css-extract-plugin
export default {"root":"nz-supports_root__VoWvd","links":"nz-supports_links__rb-1F","block":"nz-supports_block__33kko"};